import { createSelector } from 'reselect';
import { ArmyListUnitExportView, Export } from './view/export';
import {
  getArmy,
  getArmyList,
  getArmyListUnits,
  getArmyOrganisation,
  getState,
} from './exportSelector';
import { buildArmyOrganisationView } from '../make/army-organisation.presenter';
import { exportToClipboardWithOrganisation } from '@Selectors/builder/myArmyList/export/exportToClipboard';
import { IArmyListExportWithRatePros } from '@Builder/myArmyList/export/mode/ArmyListExportWithRate';
import { AppState } from '@Redux/store';
import { ConstraintItemType } from '@Models';
import { selectedElementsPresenter } from '@Selectors/builder/myArmyList/make/validation/selected-elements.presenter';

const getWithRate = (_: AppState, owsProps: IArmyListExportWithRatePros) =>
  owsProps.rate;

export const displayExportTxtWithRate = createSelector(
  [
    getState,
    getArmy,
    getArmyList,
    getArmyOrganisation,
    getArmyListUnits,
    getWithRate,
    selectedElementsPresenter,
  ],
  (
    state,
    army,
    armyList,
    armyOrganisation,
    armyListUnits,
    withRate,
    selectedElements,
  ): Export<ArmyListUnitExportView> => {
    if (!armyList) {
      return {
        name: '',
        army: '',
        game: '',
        points: 0,
        armyListUnits: [],
        exportTxt: '',
      } satisfies Export<ArmyListUnitExportView> as Export<ArmyListUnitExportView>;
    }

    let name = armyList.name.trim();
    if (name.indexOf('(') != -1) {
      name = name.substring(0, name.indexOf('(')).trim();
    }

    let units = new Array<ArmyListUnitExportView>();
    (army?.organisations ?? []).forEach((organisation) => {
      const army_list_units = armyListUnits
        .filter((item) => item.organisation_id == organisation.id)
        .sort((a, b) => a.position - b.position);

      if (army_list_units.length == 0) return;

      let organisationName = organisation.name;
      if (withRate) {
        const organisation_group =
          armyOrganisation!.army_organisation_groups.find(
            (item) => item.organisationId == organisation.id,
          );

        const seletedElement = selectedElements.find(
          (item) =>
            item.constrained.id === organisation.id &&
            item.constrained.type === ConstraintItemType.Organisation,
        );

        const armyOrganisationView = buildArmyOrganisationView(
          seletedElement!.constrained,
          organisation_group!,
          seletedElement!,
          armyList?.max ?? 2000,
        );

        armyOrganisationView.forEach((view) => {
          organisationName += ` : ${view.rate} (${view.total})`;
        });
      }

      units.push({
        name: organisationName,
        armyListUnits: army_list_units,
      } satisfies ArmyListUnitExportView as ArmyListUnitExportView);
    });

    return {
      name: `${armyList.creator ? `“${armyList.creator}“ - ` : ''}${name}`,
      army: army?.nameWithSubVersion ?? '',
      points: armyList.points,
      game: '',
      armyListUnits: units,
      exportTxt: exportToClipboardWithOrganisation(
        state,
        `${armyList.creator ? `“${armyList.creator}“ - ` : ''}${name}`,
        army?.nameWithSubVersion ?? '',
        units,
        `${armyList.points} pts`,
      ),
    } satisfies Export<ArmyListUnitExportView> as Export<ArmyListUnitExportView>;
  },
);
